import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { TRootState, TDispatch } from '../redux/redux.util.types';

export const useAppDispatch: () => TDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
